import React from 'react';
import { cn } from '../../utils/cn';
import { getLicenseUsageMetric } from '../../utils/licenseUsage';

const LicenseUsageMeter = ({
  label,
  usedRaw,
  maxRaw,
  className,
}) => {
  const { used, max, ratio, isLow, isAtLimit } = getLicenseUsageMetric(
    usedRaw,
    maxRaw
  );

  const barClass = isAtLimit
    ? 'bg-destructive'
    : isLow
      ? 'bg-amber-500'
      : 'bg-primary';

  const percent =
    max != null && max > 0
      ? Math.min(100, Math.round((used / max) * 100))
      : null;

  return (
    <div className={cn('space-y-1.5', className)}>
      <div className="flex items-center justify-between gap-2 text-xs">
        <span className="font-medium text-muted-foreground">{label}</span>
        <span
          className={cn(
            'tabular-nums font-semibold',
            isAtLimit && 'text-destructive',
            isLow && !isAtLimit && 'text-amber-700 dark:text-amber-400'
          )}
        >
          {max != null ? `${used} de ${max}` : used}
        </span>
      </div>
      {max != null ? (
        <div
          className="h-2 w-full rounded-full bg-muted overflow-hidden"
          role="progressbar"
          aria-valuenow={used}
          aria-valuemin={0}
          aria-valuemax={max}
          aria-label={label}
        >
          <div
            className={cn('h-full rounded-full transition-all', barClass)}
            style={{ width: `${percent ?? 0}%` }}
          />
        </div>
      ) : null}
    </div>
  );
};

export default LicenseUsageMeter;
